<template>
    <div>
        <v-row dense>
            <v-col cols="10">
                <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
                <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
                <p>
                    <span class="font-weight-bold mb-1">Таблица A. (фрагмент)</span><br>
                    Сведения о трудоустройстве выпускников (независимо от формы обучения)<br>
                    расчет на основе данных подсистемы «Анализ трудоустройства граждан» информационно-аналитической
                    системы
                    Общероссийская база вакансий «Работа в России» (Минтруд России)
                </p>
            </v-col>
        </v-row>
        <table>
            <thead>
            <tr>
                <th rowspan="4" colspan="3" class="text-left kcp-td">Код и наменование УГСН (НПС)</th>
                <th colspan="6">Численность выпускников (искл. продолживших обучение)</th>
                <!--      <th colspan="3">Средний бал ЕГЭ</th>-->
            </tr>
            <tr>
                <th colspan="3">всего</th>
                <th colspan="3">
                    из них - трудоустроенных
                </th>
            </tr>
            <tr>
                <th>
                    в 2019 г.
                </th>
                <th>
                    в 2020 г.
                </th>
                <th>
                    в 2021 г.
                </th>
                <th>
                    в 2020 г.
                </th>
                <th>
                    в 2021 г.
                </th>
                <th>
                    в 2022 г.
                </th>
            </tr>
            <tr>
                <th>
                    все формы
                </th>
                <th>
                    все формы
                </th>
                <th>
                    все формы
                </th>
                <th>
                    все формы
                </th>
                <th>
                    все формы
                </th>
                <th>
                    все формы
                </th>
            </tr>
            <tr style="border-top: 1px solid #B7CED9">
                <th colspan="3" style="text-align: left"><span>1</span><span style="margin-left: 66px">2</span></th>
                <th v-for="(item) in 6" :key="item">{{ item + 2 }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td colspan="3" style="text-align: left">
                    <span class="kcp-code">{{ rowOfValues.data.kcpGroup.code }}</span>
                    <span class="kcp-name">{{ rowOfValues.data.kcpGroup.name }}</span>
                </td>
                <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvtrs17, 0, 'integer') }}</td>
                <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvtrs18, 0, 'integer') }}</td>
                <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvtrs19, 0, 'integer') }}</td>
                <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nttrs17, 0, 'integer') }}</td>
                <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nttrs18, 0, 'integer') }}</td>
                <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nttrs19, 0, 'integer') }}</td>
            </tr>
            <tr>
                <td class="border-bottom-zero border-right-zero" v-for="(item) in 3" :key="item"></td>
                <td colspan="3" class="border-bottom-zero border-right-zero">
                    <img class="ww-100" :src="require('@/assets/images/brackets/bracket-3.svg')" alt=""/>
                </td>
                <td colspan="3" class="border-bottom-zero border-right-zero">
                    <img class="ww-100" :src="require('@/assets/images/brackets/bracket-3.svg')" alt=""/>
                </td>
            </tr>
            <tr>
                <td class="border-bottom-zero border-right-zero" v-for="(item) in 3" :key="item"></td>
                <td class="border-bottom-zero border-right-zero">

                </td>
                <td class="border-bottom-zero border-right-zero formul-text-table">
                    ДО = {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvtrsS3, 0, 'integer') }}
                </td>
                <td class="border-bottom-zero border-right-zero">

                </td>
                <td class="border-bottom-zero border-right-zero">

                </td>
                <td class="border-bottom-zero border-right-zero formul-text-table">
                    УТ = {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nttrsS3, 0, 'integer') }}
                </td>
            </tr>
            </tbody>
        </table>

        <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
        <div class="d-flex flex-row align-center">
            <formulsFraction :need-bottom-line="true">
                <template>
                    <div class="d-flex flex-row align-end">
                        {{ item.title }}
                        <div class="little-text ">0</div>
                    </div>
                </template>
                <template #bottom>значение<br> показателя</template>
            </formulsFraction>
            <formulsFraction :need-bottom-line="false">
                <template>
                    <span class="mt-7 alternate-text"> =</span>
                </template>
            </formulsFraction>
            <formulsFractionSimple>
                <template>
                    УТ
                </template>
                <template #bottom>
                    <span class="formul-text" style="  min-height: 49px">ДО </span>
                </template>
            </formulsFractionSimple>
            <formulsFraction :need-bottom-line="false">
                <template>
                    <span class="mt-8 alternate-text">× 100</span>
                </template>
            </formulsFraction>
            <formulsFraction :need-bottom-line="false">
                <template>
                    <span class="mt-7 alternate-text"> =</span>
                </template>
            </formulsFraction>
            <formulsFractionSimple>
                <template>
                    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nttrsS3, 0, 'integer') }}
                </template>
                <template #bottom>
                    <span class="formul-text" style="  min-height: 49px">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvtrsS3, 0, 'integer') }} </span>
                </template>
            </formulsFractionSimple>
            <formulsFraction :need-bottom-line="false">
                <template>
                    <span class="mt-8 alternate-text">× 100</span>
                </template>
            </formulsFraction>
            <formulsFraction :need-bottom-line="false">
                <template>
                    <span class="mt-7 alternate-text"> =</span>
                </template>
            </formulsFraction>
            <formulsFraction :need-bottom-line="false">
                <template>
                    <span class="mt-8">{{  $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName+'b022'], item.prd+1, 'float')  }}</span>
                </template>
            </formulsFraction>
        </div>
        <p>УТ - численность выпускников (за исключением продолживших обучение по образовательным программам высшего образования), являющихся гражданами Российской Федерации, прошедших обучение по очной форме обучения и  имевших в году, следующем за годом завершения обучения (выпуска), заработную плату в среднем размере не менее одного прожиточного минимума трудоспособного населения, установленного для региона их трудоустройства, либо зарегистрированных в указанном году в качестве индивидуальных предпринимателей или самозанятных за три отчетных года.</p>
        <p>ДО - численность выпускников (за исключением продолживших обучение по образовательным программам высшего образования), являющихся гражданами Российской Федерации, прошедших обучение по очной форме обучения, по данным за три отчетных года.</p>
        <p v-if="rowOfValues.data[item.dataFieldName+'nf22'] !== '0'">Если значение показателя ДО менее 5, фактическое значение показателя не рассчитывается, а его нормированная оценка определяется в соответствии с пунктом 6 Методики (по средним).</p>

    </div>

</template>

<script>
    import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
    import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple"

    export default {
        name: "b31",
        components: {formulsFraction, formulsFractionSimple},
        props: {
            item: {
                type: Object
            },
            rowOfValues: {
                type: Object,
                default: () => {
                }
            },
        },
        methods: {},
    }
</script>

<style lang="sass" scoped>
</style>